'use client';
import IndexListCard from '@fe-news/components/NewsList/ListItem/IndexListCard';
import { NewsCategory } from '@fe-news/constants/categories';
import { Device } from '@fe-news/constants/device';
import useFetchInfiniteListNews from '@fe-news/hooks/fetchInfiniteList/use-fetch-infinite-list-news';
import { DEFAULT_IS_HEADLINE_CATEGORIES } from '@fe-news/utils/category';
import { styled } from '@linaria/react';
import dynamic from 'next/dynamic';

const InfiniteList = dynamic(
  () => import('@fe-news/components/NewsList/NewsList').then(module_ => module_.InfiniteList),
  {
    ssr: false
  }
);

const CARD_HEIGHT = 154;

const Container = styled.div`
  width: 100%;
  min-height: 800px;
  background: white;
`;

// mobile infinite list
const CategoryInfiniteWrapper = ({ category }: { category: NewsCategory }) => {
  const isCategoryHeadline = DEFAULT_IS_HEADLINE_CATEGORIES.includes(category) ? '1' : '0';

  const { data, isItemLoaded, loadMoreItems, total } = useFetchInfiniteListNews({
    category: category.replace('_all', ''),
    isCategoryHeadline,
    dates: [],
    isShowReportNews: false, // 手機的無限滾動列表不需要顯示第八則基金報導
    isShowAd: true,
    device: Device.MOBILE,
    enableFetchQuotes: true
  });

  return (
    <Container>
      <InfiniteList
        data={data}
        isItemLoaded={isItemLoaded}
        loadMoreItems={loadMoreItems}
        Card={IndexListCard}
        total={total}
        cardHeight={CARD_HEIGHT}
      />
    </Container>
  );
};

export default CategoryInfiniteWrapper;
